import { FiMoon } from 'react-icons/fi';
import { useProviderTheme } from '../../contexts/ProviderThemeContext';

export default function ProviderThemeSwitcher() {
    const providerTheme = useProviderTheme();
    if (!providerTheme?.enabled) return null;
    const { theme, toggleTheme, isSaving } = providerTheme;
    const isDark = theme === 'dark';

    return (
        <button
            type="button"
            className="provider-theme-switcher"
            role="switch"
            aria-checked={isDark}
            aria-label="Dark theme"
            aria-busy={isSaving}
            disabled={isSaving}
            onClick={toggleTheme}
        >
            <FiMoon aria-hidden="true" />
            <span>Dark Theme</span>
            <span className="provider-theme-switcher-track" aria-hidden="true">
                <span />
            </span>
        </button>
    );
}
